export default function getUserIdToken(app) {
  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return app.auth().currentUser.getIdToken(forceRefresh);
}